import { StorageSerializers } from '@vueuse/core'
import type { RouteLocation } from '#vue-router'
import { LocalStorage } from '~/models'
import type { ProductEntrypoint } from '~/models/product'

export const useProductEntrypointList = (props: {
  pzn?: MaybeRefOrGetter<string>
  pzns?: MaybeRefOrGetter<string[]>
  listName?: MaybeRefOrGetter<ProductEntrypoint['listName']>
} | undefined) => {
  const productEntrypointList = useLocalStorage<ProductEntrypoint[]>(LocalStorage.ProductEntrypointsList, null, {
    serializer: StorageSerializers.object,
  })

  const getProductIndex = (pzn?: string): number | undefined => {
    const pznList = toValue(props?.pzns)
    if (!pzn || !pznList?.length) {
      const productEntrypoint = productEntrypointList.value?.find((entrypoint: ProductEntrypoint) => entrypoint.pzn === pzn)
      if (!productEntrypoint)
        return undefined
      else
        return productEntrypoint.index ?? 1
    }
    return pznList.indexOf(pzn) + 1
  }

  const getProductListName = (pzn: string): string => {
    const productEntrypoint = productEntrypointList.value?.find((entrypoint: ProductEntrypoint) => entrypoint.pzn === pzn)
    return productEntrypoint?.listName ?? ''
  }

  const addProductEntrypoint = (product: Partial<ProductEntrypoint> = {}) => {
    const pzn = product.pzn ?? toValue(props!.pzn)
    const index = product.index ?? getProductIndex(pzn)
    const listName = product.listName ?? toValue(props!.listName)

    if (!listName)
      return

    productEntrypointList.value ??= []

    const route = useRoute()
    const productListName = computed(() => {
      const routes: RouteLocation['name'][] = [
        'produkt-productName-pzn',
        'pharmacyName-pharmacyPlz-pharmacyId-produkt-productName-pzn',
        'themenuebersicht',
        'themenuebersicht-slug',
        'topic',
        'topic-slug',
      ]

      return routes.includes(route.name) ? 'recommendations' : listName
    })

    // TODO: on FEC1 there is also 'saisonal' list name type (we dont have such Carousel yet), and convertUrl2Slug() fallback
    const newEntrypoint = {
      pzn: pzn ?? null,
      index: index ?? null,
      listName: productListName.value ?? '',
    }

    const alreadyExists = productEntrypointList.value.some(item => isEqual(item, newEntrypoint))

    if (!alreadyExists) {
      productEntrypointList.value.push(newEntrypoint)
    }
  }

  return {
    productEntrypointList,
    addProductEntrypoint,
    getProductListName,
    getProductIndex,
  }
}
